import Vue from 'vue'
import Chat from '@/plugins/Chat'
import config from '@/config'

export const openWebSocket = () => {
  const baseApiUrl = config.URL

  const chat = new Chat(baseApiUrl + ':8000/chat')
  Vue.prototype.$chat = chat
}
